import React from "react";
import {
  Box,
  Paper,
  Typography,
  List,
  ListItemButton,
  ListItemText,
  Divider,
} from "@mui/material";

const formatFullName = (u) => `${u.firstName} ${u.lastName}`;

const UserList = ({ users, selectedUserId, height = 680, onSelect }) => {
  const heightValue = height === "100%" ? "100%" : `${height}px`;

  return (
    <Paper elevation={1} sx={{ p: 0, height: heightValue, overflow: "hidden" }}>
      <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
        <Box
          sx={{
            p: 1.5,
            borderBottom: "1px solid #e0e0e0",
            backgroundColor: "#f7f7f7",
          }}
        >
          <Typography
            variant="subtitle2"
            sx={{ fontWeight: 600, fontSize: "16px" }}
          >
            Users
          </Typography>
        </Box>

        <Box sx={{ flex: 1, overflowY: "auto" }}>
          <List disablePadding>
            {users.map((u, index) => (
              <React.Fragment key={u.id}>
                <ListItemButton
                  selected={selectedUserId === u.id}
                  onClick={() => onSelect && onSelect(u.id)}
                  sx={{
                    alignItems: "center",
                    py: 1.25,
                    gap: 2,
                    flexWrap: "nowrap",
                  }}
                >
                  <Box
                    aria-label={u.active ? "Active user" : "Inactive user"}
                    sx={{
                      width: 16,
                      height: 16,
                      borderRadius: "50%",
                      backgroundColor: u.active ? "#2e7d32" : "#9e9e9e",
                      border: `2px solid ${u.active ? "#c8e6c9" : "#e0e0e0"}`,
                      outline: "1px solid rgba(0,0,0,0.04)",
                      outlineOffset: 0,
                      flexShrink: 0,
                    }}
                  />

                  <ListItemText
                    sx={{ flex: 1, minWidth: 0 }}
                    primary={
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: 600,
                          lineHeight: 1.2,
                          fontSize: "16px",
                        }}
                      >
                        {formatFullName(u)}
                      </Typography>
                    }
                    secondary={
                      <Box>
                        <Typography
                          variant="body2"
                          sx={{ color: "#666", fontSize: "14px" }}
                        >
                          {u.persona}
                        </Typography>

                        <Typography
                          variant="body2"
                          sx={{ color: "#888", fontSize: "14px" }}
                        >
                          {u.email}
                        </Typography>
                      </Box>
                    }
                  />
                </ListItemButton>

                {index < users.length - 1 && <Divider component="li" />}
              </React.Fragment>
            ))}
          </List>
        </Box>
      </Box>
    </Paper>
  );
};

export default UserList;
